import React from 'react';
import {FormattedMessage} from 'react-intl';
import Container from '../common/index';
import {SubWrapper, Item, CircleWrapper, Circle} from './styles';

const StepHeader = ({step, message_id}) => (
  <SubWrapper>
    <Container>
      <Item>
        <CircleWrapper>
          <Circle>{step}</Circle>
        </CircleWrapper>
        <FormattedMessage id={message_id} />
      </Item>
    </Container>
  </SubWrapper>
);

export default StepHeader;
